import * as AuthRegAndMqttUtils from "./AuthRegAndMqtt";

import { kColorBlue, kColorGreen, kColorReset } from "../common/colorConst";

// MQTTライブラリのインポート
const mqtt = require("mqtt/dist/mqtt");

// トピックとメッセージの保存用配列
const topicMessage = [];

// CloudServer MQTTエンドポイントのURL
const cloudServerUrl =
  "wss://" + process.env.REACT_APP_IOT_CORE_ENDPOINT + ":443/mqtt";
export const cloudBrokerUrl = cloudServerUrl;

// AWS IoT Core MQTTカスタムオーソライザ名
export const customAuthorizerName =
  "?x-amz-customauthorizer-name=" +
  process.env.REACT_APP_IOT_CORE_CUSTOM_AUTH_NAME;

// AWS IoT Core MQTTブローカーのクライアントIDヘッダー（この文字列の後にランダムな数値が追加されます）
const clientIdHeader = "haudi";

// MQTT接続用のクライアント
export let mqttClient: any;
const mqttClients: { [key: string]: any } = {};


// Haudi標準MQTTメッセージ用定数
const haudiTopic1 = "haudi";
const haudiTopic2 = "dc2.0";

export function connectToCloudServer(uuid: string) {
  console.log(kColorBlue + "CloudServer MQTTブローカーに接続しています。");
  const mqttOptions = {
    username: uuid + customAuthorizerName,
    password: AuthRegAndMqttUtils.uuidToMqttPasswordDC(uuid),
    clientId: generateMqttClientId(),
    transformWsUrl: (url: any, options: any, client: any) => {
      console.log("connectToCloudServer - transformWsUrlが呼び出されました。");
      client.options.username = uuid + customAuthorizerName;
      client.options.password = AuthRegAndMqttUtils.uuidToMqttPasswordDC(uuid);
      client.options.clientId = generateMqttClientId();
      return url;
    },
    resubscribe: false,
  };
  console.log(
    "connectToCloudServer - mqttOptions: " + JSON.stringify(mqttOptions),
  );

  mqttClient = mqtt.connect(cloudBrokerUrl, mqttOptions);
  // mqttClient = mqtt.connect('ws://192.168.86.37:9001'); // ローカルテスト用

  console.log("MQTTコネクト済み");
  // setupClientEvents();

  if (uuid) {
    // MQTTトピック
    // mqttClient.subscribe("haudi/dc2.0/+/door/+/status");
    mqttClient.subscribe("haudi/dc2.0/" + uuid + "/door/+/status");
    mqttClient.subscribe("haudi/dc2.0/" + uuid + "/door/+/status_response");

    console.log(kColorGreen + "UUID:" + uuid + "→MQTTサブスクライブ済み");

    const topic = "haudi/dc2.0/" + uuid + "/door/door1/status_request";
    const message = "{}";

    mqttClient.publish(topic, message);
    console.log(
      kColorBlue +
        "ステータスリクエスト" +
        "topic:" +
        topic +
        "→メッセージ：" +
        message,
    );
  } else {
    console.log("UUIDがありません。");
  }
}


export function connectMultipleSDCs(sdcs: Array<{ uuid: string; doorPlace: string }>) {
  if (!sdcs || sdcs.length === 0) {
    console.log("SDCsが指定されていません。");
    return null;
  }

  // メインのMQTTクライアントを作成（最初のSDCのUUIDを使用）
  const mainUuid = sdcs[0].uuid;
  if (!mainUuid) {
    console.error("メインのUUIDが無効です。");
    return null;
  }

  const mqttOptions = {
    username: mainUuid + customAuthorizerName,
    password: AuthRegAndMqttUtils.uuidToMqttPasswordDC(mainUuid),
    clientId: generateMqttClientId(),
    transformWsUrl: (url: any, options: any, client: any) => {
      client.options.username = mainUuid + customAuthorizerName;
      client.options.password = AuthRegAndMqttUtils.uuidToMqttPasswordDC(mainUuid);
      client.options.clientId = generateMqttClientId();
      return url;
    },
    resubscribe: false,
  };

  console.log("Connecting to MQTT broker with options:", mqttOptions);

  const client = mqtt.connect(cloudBrokerUrl, mqttOptions);
  mqttClients[mainUuid] = client;

  client.on('connect', () => {
    console.log(`メインクライアント(${mainUuid})が接続されました`);
    
    // 全てのSDCのトピックをサブスクライブ
    sdcs.forEach(sdc => {
      if (sdc.uuid) {
        const statusTopic = `haudi/dc2.0/${sdc.uuid}/door/door1/status`;
        client.subscribe(statusTopic, (err: any) => {
          if (err) {
            console.error(`トピックのサブスクライブに失敗: ${statusTopic}`, err);
          } else {
            console.log(`サブスクライブ成功: ${statusTopic}`);
          }
        });
      }
    });
  });

  client.on('error', (error: any) => {
    console.error('MQTT接続エラー:', error);
  });

  return client;
}

export function generateMqttClientId() {
  const randomNumberString = Math.floor(Math.random() * 9999999999).toString();
  return clientIdHeader + "dc_" + getBrowserName() + "_" + randomNumberString;
}

export function getBrowserName() {
  let browser = "Unknown";
  if (navigator.userAgent) {
    const userAgentData = navigator.userAgent;
    if (userAgentData.indexOf("Edge") !== -1) {
      browser = "Edge";
    } else if (userAgentData.indexOf("Chrome") !== -1) {
      browser = "Chrome";
    } else if (userAgentData.indexOf("Firefox") !== -1) {
      browser = "Firefox";
    } else if (userAgentData.indexOf("Safari") !== -1) {
      browser = "Safari";
    }
  } else {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("Edge") !== -1 || userAgent.indexOf("Edg") !== -1) {
      browser = "Edge";
    } else if (
      userAgent.indexOf("Trident") !== -1 ||
      userAgent.indexOf("MSIE") !== -1
    ) {
      browser = "IE";
    } else if (
      userAgent.indexOf("OPR") !== -1 ||
      userAgent.indexOf("Opera") !== -1
    ) {
      browser = "Opera";
    } else if (userAgent.indexOf("Chrome") !== -1) {
      browser = "Chrome";
    } else if (userAgent.indexOf("Firefox") !== -1) {
      browser = "Firefox";
    } else if (userAgent.indexOf("Safari") !== -1) {
      browser = "Safari";
    }
  }
  console.log("getBrowserName - " + browser);
  return browser;
}

// JSONかどうかを判定する関数
export function isValidJson(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function identifyTopicType(topic: string) {
  if (topic.startsWith(haudiTopic1 + "/" + haudiTopic2 + "/")) {
    return haudiTopic1;
  }
  return "noMatch";
}

export function parseTopic(topic: string) {
  const topicSplitBySlash = topic.split("/");
  const parsedTopic = {
    top: topicSplitBySlash[0],
    codeAndVersion: topicSplitBySlash[1],
    encryptedUuid: topicSplitBySlash[2],
    deviceType: topicSplitBySlash[3],
    deviceName: topicSplitBySlash[4],
    messageType: topicSplitBySlash[5],
  };
  return parsedTopic;
}

// Haudi形式のメッセージを受信した時の処理
export function handleReceivedMessage(
  topic: string,
  message: { toString: () => any },
) {
  const messageString = message.toString();
  console.log(
    kColorGreen +
      "handleReceivedMessage - トピック[" +
      topic +
      "], メッセージ[" +
      JSON.stringify(messageString) +
      "]." +
      kColorReset,
  );
  const parsedTopic = parseTopic(topic);
  if (
    parsedTopic.top !== haudiTopic1 ||
    parsedTopic.codeAndVersion !== haudiTopic2
  ) {
    console.error(
      "handleReceivedMessage - トピックエラー、Haudi形式ではありません: [" +
        parsedTopic.top +
        "/" +
        parsedTopic.codeAndVersion +
        "] != [" +
        haudiTopic1 +
        "/" +
        haudiTopic2 +
        "]",
    );
    return;
  }

  topicMessage[0] = topic;
  topicMessage[1] = JSON.stringify(messageString);
}

// MQTTクライアントの切断
export function disconnectMultipleSDCAll() {
  Object.values(mqttClients).forEach(client => {
    if (client) {
      client.end();
    }
  });
  // クライアントマップをクリア
  Object.keys(mqttClients).forEach(key => delete mqttClients[key]);
}

// メッセージハンドラーの設定
export function setupMessageHandler(
  client: any,
  onMessage: (topic: string, message: Buffer) => void
) {
  if (!client) {
    console.error('MQTTクライアントが初期化されていません。');
    return;
  }

  client.on('message', (topic: string, message: Buffer) => {
    try {
      onMessage(topic, message);
    } catch (error) {
      console.error('メッセージ処理エラー:', error);
    }
  });
}